import { Typography } from 'fronton-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  formSubmitNotification,
  formSubmitNotificationIcon,
  formSubmitNotificationIconHolder,
  formSubmitNotificationContent,
  formSubmitNotificationTitle,
} from './styles';

export const FormSubmitNotification: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={formSubmitNotification}>
      <div className={formSubmitNotificationIconHolder}>
        <svg
          className={formSubmitNotificationIcon}
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40V35.5556C28.5911 35.5556 35.5556 28.5911 35.5556 20C35.5556 11.4089 28.5911 4.44444 20 4.44444C11.4089 4.44444 4.44444 11.4089 4.44444 20H0C0 8.95431 8.95431 0 20 0Z" />
        </svg>
      </div>
      <div className={formSubmitNotificationContent}>
        <Typography className={formSubmitNotificationTitle} variant="m" size="subtitle">
          {t('reviews.form.submit.part4')}
        </Typography>
        <Typography variant="s" size="body_short">
          {t('reviews.form.submit.part5')}
        </Typography>
      </div>
    </div>
  );
};
